import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import styled from "styled-components";
import logo from "./../../images/new-logo.svg";
import { FlatButton, CollapseContainer } from "./../commons/";
import { Container, Row, Col, Button } from "reactstrap";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { width } from "@material-ui/system";
import { withApollo } from 'react-apollo';
import gql from "graphql-tag";

const MobileHeaderContainer = styled.div`

  @media (min-width: ${props => props.theme["mobileBreakpoint"]}) {
    display: none;
  }

  .container {
    max-width: unset;
  }

  height: 85px;
  display: flex;
  align-items: center;

  #mobileHeaderLogoLink {
    cursor: pointer;
    width: 100px;
    z-index: 11;
  }

  img {
    width: 100%;
  }

  button.hamburger {
    outline: none;
    cursor: pointer;
    float: right;
    padding-right: 0px;
    z-index: 1000;

    &:hover {
      color: inherit;
      opacity: unset;
    }
  }
`;

const SideMenuContainer = styled.div`
  a,
  .collapse-link {
    color: #000000;
    font-size: ${props => props.theme["$font-size-xxs"]};
    font-weight: ${props => props.theme["$weight-bold"]};
    letter-spacing: 3px;
    text-transform: uppercase;
    cursor: pointer;
    padding-bottom: 10px;
    margin-right: 30px;
    display: block;

    &:hover {
      color: ${props => props.theme["primaryHoverColor"]};
    }

    &.active {
      border-bottom: 1px solid ${props => props.theme["primaryColor"]};
    }
  }

  .logo-text {
    color: #37312f;
    font-size: 9px;
    font-weight: ${props => props.theme["$weight-regular"]};
    letter-spacing: 3.6px;
    text-transform: uppercase;
    margin-top: 0.5rem;
  }

  .mob-nav-cart {
    margin-top: 20px;
    margin-left: auto;
    margin-right: 20px;
  }
`;

const CollapseTriggerContainer = styled.div`
  color: pink;
`;

const PUBLICATION_LINK_LIST = [
  {
    label: "Magazine",
    link: "/categories?product-type=magazine"
  },
  {
    label: "Books",
    link: "/categories?product-type=books"
  },
  {
    label: "Articles",
    link: "/categories?product-type=articles"
  },
  {
    label: "Gift Sets",
    link: "/categories?product-type=gift-sets"
  }
];

const ABOUT_LINK_LIST = [
  {
    label: "Our Story",
    link: "/aboutus"
  },
  {
    label: 'Timeline',
    link: '/history',
  },
  {
    label: "Trustees",
    link: "/trustees"
  },
  {
    label: "Team",
    link: "/team"
  },
  {
    label: "Patrons & Partners",
    link: "/supporters"
  }
];

const LOAD_DIARY = gql`
  query diary {
    productTypes(first:2){
      edges{
        node{
          id
          name
          products(first:1){
            edges{
              node{
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

class MobileHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sideMenuOpen: false,
      diaryId: ''
    };
  }

  componentDidMount(){
    this.props.client
      .query({
        query: LOAD_DIARY,
      })
      .then(({ data, loading }) => {
        if(!loading){
          const type = data.productTypes.edges.find((productType) =>  productType.node.name === 'Diary')
          if(type && type.node && type.node.products && type.node.products.edges)
            this.setState({diaryId: type.node.products.edges[0].node.id})
        }
      });
  }
  handleHamburgerClick = () =>
    this.setState({ sideMenuOpen: !this.state.sideMenuOpen });

  collapseTriggerElementPublications = () => (
    <CollapseTriggerContainer>
      <p className="collapse-link mb-0">PUBLICATIONS</p>
    </CollapseTriggerContainer>
  );

  collapseBodyPublications = (diaryId) => (
    <div>
      {PUBLICATION_LINK_LIST.map(({ label, link }) => (
        <Link onClick={this.handleHamburgerClick} to={link? link: `/product/${diaryId}`}>
          {label}
        </Link>
      ))}
    </div>
  );

  collapseBodyAbout = () => (
    <div>
      {ABOUT_LINK_LIST.map(({ label, link }) => (
        <Link onClick={this.handleHamburgerClick} to={link}>
          {label}
        </Link>
      ))}
    </div>
  );

  collapseTriggerElementAbout = () => (
    <CollapseTriggerContainer>
      <p className="collapse-link mb-0">ABOUT US</p>
    </CollapseTriggerContainer>
  );

  sideMenuList = () => (
    <Container id="sideMenuContainer" className="py-4" style={{ backgroundColor: "white" }}>
      <Row>
      <Col>
            <Link
              onClick={this.handleHamburgerClick}
              id="mobileHeaderLogoLink"
              to="/"
            >
              <img className="img-fluid" src={logo} />
            </Link>
        </Col>
        <Col>
        {this.props.cartQuantity > 0 &&
          <a href={this.props.cartQuantity > 0 ? "/checkout/cart" : ""}> <FlatButton
                  onClick={this.handleHamburgerClick}
                  className="mob-nav-cart"
                  colorType="primary"
                >
                  <span style={{ color: "black"}} className="color-black">Cart—</span>
                  {this.props.cartQuantity}
                </FlatButton> </a>
            }
        </Col>
      </Row>
      <Row>
        <Col lg="12" className="my-5">
          <CollapseContainer
            trigger={this.collapseTriggerElementPublications}
            body={() => this.collapseBodyPublications(this.context)}
          />
          <CollapseContainer
            trigger={this.collapseTriggerElementAbout}
            body={this.collapseBodyAbout}
          />
          <Link onClick={this.handleHamburgerClick} to="/donate">Donate</Link>
          <Link onClick={this.handleHamburgerClick} to="/contactus">
            Contact
          </Link>
          <Link
            onClick={this.handleHamburgerClick}
            to="/blog"
          >
            MARG-E-ZINE
          </Link>
          <Link onClick={this.handleHamburgerClick} to="/advertise">
            Advertise
          </Link>
          
          <Link onClick={this.handleHamburgerClick} to="/event">Events</Link>
          <Link onClick={this.handleHamburgerClick}  to="/collaborate">Collaborate</Link>
          <Link onClick={this.handleHamburgerClick} to="/submit-proposals">Submit Proposals</Link>
          <Link onClick={this.handleHamburgerClick} to="/bookstores">Book stores</Link>
          {/* <Link onClick={this.handleHamburgerClick}>Film Archive</Link> */}
          <Link onClick={this.handleHamburgerClick} to="/movies">Films</Link>
          {this.state.diaryId && <Link onClick={this.handleHamburgerClick} to={"/product/" + this.state.diaryId}>Diary</Link>}
          {!this.props.isLoggedIn && (
            <Link onClick={this.handleHamburgerClick} to="/login">
              Login
            </Link>
          )}
          <Link
            className="m-0"
            to="/search"
            onClick={this.handleHamburgerClick}
          >
            SEARCH
          </Link>
          {this.props.isLoggedIn && (
            <div>
              <Link onClick={this.handleHamburgerClick} to="/myaccount">
                My Account
              </Link>
              <Link
                onClick={() => {
                  this.handleHamburgerClick();
                  this.props.logout();
                }}
              >
                SIGN OUT
              </Link>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );

  render() {
    return (
      <MobileHeaderContainer>
        <Container className="px-0">
          <Row>
            <Col lg="12 d-flex justify-content-between align-items-center">
              <Link id="mobileHeaderLogoLink" to="/">
                <img className="img-fluid" src={logo} />
              </Link>
              <div className="d-flex align-items-center">
                <button
                  onClick={this.handleHamburgerClick}
                  className={
                    "hamburger hamburger--collapse " +
                    (this.state.sideMenuOpen ? "is-active" : "")
                  }
                  type="button"
                >
                  <span className="hamburger-box">
                    <span className="hamburger-inner"></span>
                  </span>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
        <SwipeableDrawer
          open={this.state.sideMenuOpen}
          onClose={this.handleHamburgerClick}
          onOpen={this.handleHamburgerClick}
        >
          <SideMenuContainer>{this.sideMenuList()}</SideMenuContainer>
        </SwipeableDrawer>
      </MobileHeaderContainer>
    );
  }
}

export default withApollo(withRouter(MobileHeader));
